import httpClient from '../utils/httpClient';

const API_URL = '/current-account';

export const createAccount = async (data) => {
  try {
    const response = await httpClient.post(`${API_URL}/account`, data);
    return response;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getAccountByStudent = async (studentId) => {
  try {
    const response = await httpClient.get(`${API_URL}/account/student/${studentId}`);
    return response;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const createMovement = async (data) => {
  try {
    const response = await httpClient.post(`${API_URL}/movement`, data);
    return response;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getMovements = async (accountId, filters = {}) => {
  try {
    const cleanFilters = Object.fromEntries(
      Object.entries(filters).filter(([, v]) => v !== '' && v != null)
    );
    const params = new URLSearchParams(cleanFilters).toString();
    const response = await httpClient.get(
      `${API_URL}/account/${accountId}/movements${params ? `?${params}` : ''}`
    );
    return response;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const cancelMovement = async (movementId, data) => {
  try {
    const response = await httpClient.put(
      `${API_URL}/movement/${movementId}/cancel`,
      data
    );
    return response;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const recalculateBalance = async (accountId) => {
  try {
    const response = await httpClient.put(
      `${API_URL}/account/${accountId}/calculate-balance`
    );
    return response;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getAllAccountsSummary = async (filters = {}) => {
  try {
    const params = new URLSearchParams(filters).toString();
    const response = await httpClient.get(
      `${API_URL}/accounts${params ? `?${params}` : ''}`
    );
    return response;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const downloadStudentReceiptPdf = async (movementId) => {
  const token = localStorage.getItem('token');
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const response = await fetch(`${baseUrl}/current-account/receipt/${movementId}/pdf`, {
    headers: { Authorization: token ? `Bearer ${token}` : '' },
  });
  if (!response.ok) throw new Error('Error al descargar recibo');
  return response.blob();
};
